import React from 'react'
import SearchBar from '../../../../../common/searchbar/SearchBar'
import CollapsableText from '../../../../../common/card/CollapsableText'
import Icons from '../../../../../common/icons/Icons'
import Button from '../../../../../common/button/Button'
import { getSelectedData } from '../Utils'

const MembersFilterContent = ({
  filterData,
  from,
  data,
  table,
  columns,
  rowSelection,
  setRowSelection,
  sorting,
  setSorting,
  globalFilter,
  setGlobalFilter,
  setData,
  setColumnFilters
}) => {

  const isPendingInvitesTable = from === 'Pending Invites Table'
  const isMembersTable = from === 'Members Table'
  const filteredId = isMembersTable ? 'role' : isPendingInvitesTable && 'invitationRole'
  const filterTableData = table.getRowModel().rows
  const { checkedRoleValue, checkedRoleCount } = getSelectedData( data )

  const updateSelectedRowData = ( itemName, itemKey, itemValue ) => {
    setData(prevData =>
      prevData.map(filterData => {
        if ( filterData.name === 'Role' ) {
          return {
            ...filterData,
            items: filterData.items.map(item => {
              if ( item.name === itemName ) {
                return {
                  ...item,
                  [itemKey]: itemValue
                }
              }
              return item
            })
          }
        }
        return filterData
      })
    )
  }

  const handleInputCheckbox = ( event ) => {
    const { name, value, checked } = event.target
    if( parseInt( value ) === 0 )  return
    updateSelectedRowData( name, 'checked', checked )
  }

  const handleResetFilter = () => {
    setColumnFilters([])
    setGlobalFilter('')
    setData([...filterData])
  }

  const handleShowResults = () => {
    setColumnFilters([
      {
        id: filteredId,
        value: checkedRoleValue
      }
    ])
  }

  return (
    <div className='msync-dropdown__panel__body msync-filter-form' style={{ width: '320px' }}>
      <div className='msync-members-filter-search'>
        <SearchBar globalFilter={ globalFilter } setGlobalFilter={ setGlobalFilter } />
      </div>

      <div className='msync-members-filter-collapsable'>
        {
          table && filterTableData.length !== 0
          ? filterTableData.map( ( row ) => (
            <>
              {
                row.original.name === 'Role' && 
                <CollapsableText key={ row.id } collapsed={ checkedRoleValue.length !== 0 } title={ row.original.name }>
                  <div className='msync-checkbox'>
                    {
                      row.original.items && row.original.items.map((item, key) => (
                        <>
                        <div key={item.name} className={`msync-checkbox-row ${item.count === 0 ? 'msync-disabled' : ''}`}>
                          <input 
                            type="checkbox"
                            id={`role-${item.name}`} 
                            onChange={(e) => handleInputCheckbox( e ) } 
                            name={item.name} 
                            value={item.count}
                            checked={ item.checked }
                            disabled={ item.count === 0 }
                          />
                          <label for={`role-${item.name}`}>{ item.value }</label>
                          <span>({ item.count })</span>
                        </div>
                        </>
                      ))
                    }
                    {/* <div>
                      <span type='button' className='msync-span-anchor' onClick={ () => console.log('view all') }>View all</span>
                    </div> */}
                  </div>
                </CollapsableText>
              }
              {/* {
                row.original.name === 'Presets' && 
                <CollapsableText key={ row.id } collapsed={ false } title={ row.original.name }>
                  <p>Presets Content</p>
                </CollapsableText>
              } */}
              {/* {
                row.original.name === 'Reporting Groups' && 
                <CollapsableText key={ row.id } collapsed={ false } title={ row.original.name }>
                  <p>Reporting Groups Content</p>
                </CollapsableText>
              } */}
            </>
          ))
          : <div>
              <small>No data found...</small>
            </div>
        }
      </div>
      <div className='msync-members-filter-footer'>
        <Button
          name={`Show ${ checkedRoleCount !== 0 ? checkedRoleCount : '' } Results`}
          className='msync-primary-btn'
          onClick={ () => handleShowResults() }
          disabled={ checkedRoleCount === 0 }
        />
        <Button
          name='Reset'
          className='msync-default-btn'
          onClick={ () => handleResetFilter() }
        />
      </div>
    </div>
  )
}

export default MembersFilterContent
